module.exports = __webpack_public_path__ + "static/img/350.7d7d83b4.png";